module.exports = __webpack_public_path__ + "static/img/baoye.54c573ef.png";